import { useEffect, useMemo, useState } from "react";
import { Box } from "@mui/material";

import AppBar from "components/AppBar";
import PageLayout from "components/PageLayout";
import PageLoader from "components/PageLoader";
import useNotifier from "hooks/useNotifier";
import useBoundStore from "store";
import MoneyManagerApi, { MoneyManagerData, EMPTY_MONEY_MANAGER_DATA } from "api/money-manager";
import { VoteType } from "api/vote";
import Summary from "./Summary";

export interface TimelineMoneyManagerProps {
  onBack?: () => void;
}

export default function TimelineMoneyManager(props: TimelineMoneyManagerProps) {
  const { onBack } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [moneyManagerData, setMoneyManagerData] = useState<MoneyManagerData | null>(null);

  const selected = useBoundStore((state) => state.selected);
  const userProfileId = useBoundStore((state) => state.user.profile?.id);
  const { timelineEvent } = selected;
  const { showNotification } = useNotifier();
  const moneyManagerApi = useMemo(() => new MoneyManagerApi(showNotification), [showNotification]);

  const participantIds = (timelineEvent?.votes ?? [])
    .filter((v) => v.type === VoteType.PARTICIPATING)
    .map((v) => v.uid);
  const participants = (timelineEvent?.users ?? []).filter((u) => participantIds.includes(u.uid));

  useEffect(() => {
    (async () => {
      if (timelineEvent?.event && selected.groupId) {
        const { data } = await moneyManagerApi.getMoneyManagerData(timelineEvent.event.id, selected.groupId);
        setMoneyManagerData(data?.data ?? EMPTY_MONEY_MANAGER_DATA);
      }
      setIsLoading(false);
    })();
  }, [timelineEvent?.event?.id, selected.groupId]);

  if (isLoading) {
    return (
      <PageLayout appBar={<AppBar noRadius title='Money Manager' onBack={onBack} />}>
        <PageLoader />
      </PageLayout>
    );
  }

  return (
    <PageLayout appBar={<AppBar noRadius title='Money Manager' onBack={onBack} />}>
      <Box p={2}>
        <Summary
          data={moneyManagerData ?? EMPTY_MONEY_MANAGER_DATA}
          isAdmin={false}
          participants={participants}
          onSave={() => {}}
          userProfileId={userProfileId}
        />
      </Box>
    </PageLayout>
  );
}
